// Auto-generated from brand/creator.json
// Do not edit manually. Run: python scripts/sync-brand.py

export const CREATOR = {
  name: { zh: "慕湮", en: "muyaan" },
  title: { zh: "风光摄影师", en: "Landscape Photographer" },
  avatar: "/avatar.jpg",
  bio: {
    zh: `向着地平线奔跑，以寂静喧嚣🌄
定格宁静。活在混乱🌪️
脑海充满疯狂幻象🌌`,
    en: `Running towards the horizon to quiet the noise🌄
Capturing peace. Living in chaos🌪️
Mind full of mad visions🌌`,
  },
  philosophy: {
    zh: `按下快门只是开始，照片的另一半生命在后期。但后期不该被重复劳动占满——让机器做机器擅长的，让人做人擅长的。`,
    en: `Pressing the shutter is only the beginning — the other half of a photograph's life happens in post. But post shouldn't be eaten by repetitive grunt work: let the machine do what machines are good at, so the human can do what only humans can.`,
  },
} as const;

export const CONTACT = {
  email: "tyc.allen@gmail.com",
  galleryUrl: "https://muyaan.top/gallery",
  websiteUrl: "https://muyaan.top",
} as const;

export const SOCIAL_LINKS = [
  { platform: "Instagram", url: "https://www.instagram.com/muyaan_photo/", icon: "instagram" },
  { platform: "小红书", url: "https://xhslink.com/m/MXkcT1uEnD", icon: "xiaohongshu" }
] as const;

export type Creator = typeof CREATOR;
export type Contact = typeof CONTACT;
export type SocialLink = typeof SOCIAL_LINKS[number];
